"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskReviewProgress = void 0;
var task_review_progress_component_1 = require("./task-review-progress.component");
Object.defineProperty(exports, "TaskReviewProgress", { enumerable: true, get: function () { return task_review_progress_component_1.TaskReviewProgress; } });
